// extracted by mini-css-extract-plugin
module.exports = {"sidebarItem":"HowToiSideBar_sidebarItem__1E19y","borderOff":"HowToiSideBar_borderOff__VB6KU"};